import { Controller } from '@hotwired/stimulus';
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import UserForm from '/components/UserForm.vue';
import '../stylesheets/custom.scss';

export default class extends Controller {
  static targets = ['vueapp'];
  connect() {
    const app = createApp(UserForm);
    app.use(ElementPlus);
    app.mount(this.vueappTarget);
  }
}
